/**
 * This is a custom hook for writing data into memory. It provides a setter function for setting the memory with data
 */

import Memory from "../../../service/memory/base/Memory";
import MemoryOperation from "../../../service/memory/enum/MemoryOperation";

export const useWriteMemory = () => {
  const writeMemory = (memoryType, value, storageType) => {
    const memory = new Memory();
    const data = {};
    data["key"] = memoryType;
    data["value"] = value;
    memory.handleRequest(MemoryOperation.WRITE, memoryType, data);
  };

  return writeMemory;
};
